import type { LinkProps as RouterLinkProps } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

import ArrowForwardIosOutlined from '@mui/icons-material/ArrowForwardIosOutlined';
import { Button, Typography } from '@mui/material';

import { HStack } from '../../../Stack';

/**
 * 페이지 안에서 사용하는 메뉴의 링크 아이템.
 *
 * @package
 */
export const Link = ({
  children,
  disabled,
  ...linkProps
}: { children?: React.ReactNode; disabled?: boolean } & RouterLinkProps) => {
  return (
    <HStack bgcolor={'white'} height={56} alignItems={'center'}>
      <Button
        component={RouterLink}
        {...linkProps}
        variant="text"
        color="inherit"
        disabled={disabled}
        sx={{ flex: 1, justifyContent: 'space-between', alignItems: 'center', p: 2 }}
      >
        <Typography variant="Body_Looko">{children}</Typography>
        <ArrowForwardIosOutlined sx={{ fontSize: 16 }} />
      </Button>
    </HStack>
  );
};
